import { action } from "satcheljs";

const resetTeamSettingsStore = action(
    "resetTeamSettingsStore", () => ({})
);

export default resetTeamSettingsStore;
